import { useState, useEffect, useCallback } from 'react';
import { categoryApi } from '../api/categoryApi';

export const useCategories = () => {
    const [expenseCategories, setExpenseCategories] = useState([]);
    const [projectStatuses, setProjectStatuses] = useState([]);
    const [priorityLevels, setPriorityLevels] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadCategories = useCallback(async () => {
        try {
            setLoading(true);
            const [expenseRes, statusRes, priorityRes, rolesRes] = await Promise.all([
                categoryApi.getExpenseCategories(),
                categoryApi.getProjectStatuses(),
                categoryApi.getPriorityLevels(),
                categoryApi.getUserRoles()
            ]);

            setExpenseCategories(expenseRes.data);
            setProjectStatuses(statusRes.data);
            setPriorityLevels(priorityRes.data);
            setUserRoles(rolesRes.data);
            setError(null);
        } catch (err) {
            const message = err.response?.data?.message || 'Errore nel caricamento categorie';
            setError(message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadCategories();
    }, [loadCategories]);

    const getCategoryLabel = (category, type = 'expense') => {
        let list = [];
        switch (type) {
            case 'expense':
                list = expenseCategories;
                break;
            case 'status':
                list = projectStatuses;
                break;
            case 'priority':
                list = priorityLevels;
                break;
            case 'role':
                list = userRoles;
                break;
            default:
                return category;
        }
        const found = list.find(c => c.name === category);
        return found?.label || category;
    };

    return {
        expenseCategories,
        projectStatuses,
        priorityLevels,
        userRoles,
        loading,
        error,
        getCategoryLabel,
        refresh: loadCategories,
    };
};